module.exports = __webpack_public_path__ + "static/media/maintenance_icon.c1570250.svg";